<template>
    <div class="pb-3 pt-2 text-muted card mb-g show p-4 mb-6">
        <div class="border-top-0 border-left-0 border-right-0">
            <h4 class="mb-0 flex-1 text-dark fw-500">
                Thông tin cá nhân
            </h4>
        </div>
        <div class="mt-4">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form class="form" @submit.prevent="handleSubmit(submit)" autocomplete="off">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Số điện thoại</label>
                            <ValidationProvider vid="phone" name="Số điện thoại"
                                                :rules="{ required: true, min: 10, regex: /^(09|03|07|08|05)[0-9]{8}$/ }"
                                                v-slot="{ errors, classes }">
                                <div class="input-group">
                                    <input v-model="dataInfo.phone" ref="phone" :class="classes"
                                              placeholder="Nhập số điện thoại"
                                              class="form-control" id="phone-input" />
                                    <div class="text-danger mt-1" data-field="name" data-validator="notEmpty">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Số điện thoại liên hệ</label>
                            <ValidationProvider vid="phone_other" name="Số điện thoại liên hệ"
                                                :rules="{ required: true, min: 10, regex: /^(09|03|07|08|05)[0-9]{8}$/ }"
                                                v-slot="{ errors, classes }">
                                <div class="input-group">
                                    <input v-model="dataInfo.phone_other" ref="phone_other" :class="classes"
                                           placeholder="Nhập số điện thoại liên hệ"
                                           class="form-control" id="phone-input" />
                                    <div class="text-danger mt-1" data-field="name" data-validator="notEmpty">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Giới tính <span class="text-danger">*</span></label>
                            <ValidationProvider vid="gender" name="Giới tính"
                                                rules="required"
                                                v-slot="{ errors, classes }">
                                <div class="input-group">
                                    <el-select filterable class="w-100" placeholder="Chọn giới tính" v-model="dataInfo.gender" clearable>
                                        <el-option
                                            v-for="item in gender"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        > <span style="float: left">{{ item }}</span>
                                        </el-option>
                                    </el-select>
                                    <div class="text-danger mt-1" data-field="name" data-validator="notEmpty">
                                        {{ errors[0] }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label" for="email">Email cá nhân <span class="text-danger">*</span></label>
                            <ValidationProvider vid="email" name="Email" rules="required|email"
                                                v-slot="{ errors, classes }">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="email">@</span>
                                    </div>
                                    <input type="email" ref="email" v-model="dataInfo.email" name="email"
                                           :class="classes" class="form-control" id="email-input"
                                           placeholder="Nhập email của bạn" aria-describedby="email">
                                </div>
                                <div class="text-danger mt-1" data-field="email" data-validator="notEmpty">
                                        {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label" for="internal_email">Email nội bộ <span class="text-danger">*</span></label>
                            <ValidationProvider vid="internal_email" name="Email nội bộ" rules="required|email"
                                                v-slot="{ errors, classes }">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="internal_email">@</span>
                                    </div>
                                    <input type="internal_email" ref="internal_email" v-model="dataInfo.internal_email" name="internal_email"
                                           :class="classes" class="form-control" id="email-input"
                                           placeholder="Nhập email nội bộ của bạn" aria-describedby="internal_email">
                             
                                </div>
                                <div class="text-danger mt-1" data-field="internal_email" data-validator="notEmpty">
                                        {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Địa chỉ tạm trú <span class="text-danger">*</span></label>
                            <ValidationProvider vid="address" name="Địa chỉ tạm trú" rules="required"
                                                v-slot="{ errors, classes }">
                                <input v-model="dataInfo.address" type="text" :class="classes" class="form-control" id="address"
                                       placeholder="Nhập địa chỉ thường trú">
                                <div class="text-danger mt-1" data-field="address" data-validator="notEmpty">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Mã số BHXH <span class="text-danger">*</span></label>
                            <ValidationProvider vid="social_insurance_number" name="Mã số BHXH" rules="required"
                                                v-slot="{ errors, classes }">
                                <input v-model="dataInfo.social_insurance_number" type="text" :class="classes" class="form-control" id="social_insurance_number"
                                       placeholder="Nhập Mã số BHXH">
                                <div class="text-danger mt-1" data-field="social_insurance_number" data-validator="notEmpty">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>

                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Trình độ học vấn <span class="text-danger">*</span></label>
                            <ValidationProvider vid="education_level" name="Trình độ học vấn" rules="required"
                                                v-slot="{ errors, classes }">
                                <input v-model="dataInfo.education_level" type="text" :class="classes" class="form-control" id="education_level"
                                       placeholder="Trình độ học vấn">
                                <div class="text-danger mt-1" data-field="education_level" data-validator="notEmpty">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Trường đại học <span class="text-danger">*</span></label>
                            <ValidationProvider vid="university" name="Trường đại học" rules="required"
                                                v-slot="{ errors, classes }">
                                <input v-model="dataInfo.university" type="text" :class="classes" class="form-control" id="university"
                                       placeholder="Trường đại học">
                                <div class="text-danger mt-1" data-field="university" data-validator="notEmpty">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Chuyên ngành học <span class="text-danger">*</span></label>
                            <ValidationProvider vid="major" name="Chuyên ngành học" rules="required"
                                                v-slot="{ errors, classes }">
                                <input v-model="dataInfo.major" type="text" :class="classes" class="form-control" id="major"
                                       placeholder="Chuyên ngành học">
                                <div class="text-danger mt-1" data-field="major" data-validator="notEmpty">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                    <button :disabled="loading" class="btn bg-violet text-white waves-effect waves-themed mt-4" type="submit"><i
                        v-if="loading" class="el-icon-loading"></i> Cập nhật thông tin
                    </button>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import {SAVE_GENERAL_INFO} from "../../../../core/services/store/profile.module";

export default {
    name: "InformationGenneral",
    data()
    {
        return {
            loading: false,
            gender: [
                'Nam', 'Nữ', 'Khác'
            ],
        }
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        submit() {
          this.$store.dispatch(SAVE_GENERAL_INFO, this.dataInfo).then((res) => {
            this.$message.success({ title: 'Cập nhật thông tin', message: 'Thành công' });
          });
        }
    }
}
</script>

<style scoped>

</style>